import { render, staticRenderFns } from "./news-info.vue?vue&type=template&id=2b7f2d99&scoped=true&"
import script from "./news-info.vue?vue&type=script&lang=js&"
export * from "./news-info.vue?vue&type=script&lang=js&"
import style0 from "./news-info.vue?vue&type=style&index=0&id=2b7f2d99&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f2d99",
  null
  
)

export default component.exports